import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@gsa/afp-component-library';
import { Controller } from 'react-hook-form';

const DescriptionField = ({ control }) => {
  return (
    <Controller
      name="description"
      control={control}
      render={({ field: { value, onChange } }) => (
        <TextInput
          type="textarea"
          name="description"
          id="attachment-textarea"
          data-testid="attachment-file-description"
          label={<b>Description (optional)</b>}
          help="A few words to help identify this document"
          characterLimit={100}
          value={value}
          onChange={({ target: { value } }) => onChange(value)}
        />
      )}
    />
  );
};

DescriptionField.propTypes = {
  control: PropTypes.object.isRequired,
};

export default DescriptionField;
